export function mergeJobArrays(...arraysWithSchema) {
  const departmentGroups = {}

  arraysWithSchema?.forEach(({ data, schema }) => {
    data?.forEach((item) => {
      const department = schema.department(item)
      const jobs = schema.jobs(item) || []

      if (!departmentGroups[department]) {
        departmentGroups[department] = {
          name: department.trim(),
          jobs: [],
        }
      }

      jobs.forEach((job) => {
        departmentGroups[department].jobs.push(job)
      })
    })
  })

  return Object.values(departmentGroups)
    .filter((department) => department.jobs.length > 0)
    .sort((a, b) => a.name.localeCompare(b.name))
}
